import { useCollectionListing } from './use-collection-listing';

export const useFetchCurrency = () => {
  const { data } = useCollectionListing({ collection: 'currency' });

  return {
    data: data?.result?.records
  };
};
